module.exports = __webpack_public_path__ + "img/airklima-kontakt.e4f162b8.jpg";